import { HttpClient, HttpHeaders } from '@angular/common/http';
import { Component, OnInit, Inject, ElementRef } from '@angular/core';
import { EmpRoleInfo } from '../model/emprole.model';
import { ProjectSaleInfo } from '../model/projectsale.model';
import {
  environment
} from 'src/environments/environment';
import { ProjectInfo } from '../model/project.model';
import { ActivatedRoute, Router } from '@angular/router';
import { TokenService } from '../service/token.service';
import { GlobalService } from '../service/global.service';


@Component({
  selector: 'app-report',
  templateUrl: './report.component.html',
  styleUrls: ['./report.component.css']
})
export class ReportComponent implements OnInit {
  // Zone Search variable
  txtSearchProjectCode: string
  txtSearchProjectName: string

  ProjectOnPromise: Promise<ProjectInfo[]>
  projectList: ProjectInfo[] = [];
  countprojectlist: number;

  EmpRoleOnPromise: Promise<EmpRoleInfo[]>
  EmpRoleList: EmpRoleInfo[] = [];


  public currentPageNumber: number
  public totalPages: number
  RoleCode: any
  EmpTotal: any
  isOnUpdate: boolean;
  isSubmitted: any;
  baseurl: string;

  IsSearch: boolean = false;

  _ForK2: string;
  _EmpCode: string;
  _UserName: string;
  isSearchSubmitted: boolean = false;


  constructor(private httpClient: HttpClient, @Inject('BASE_URL') baseUrl: string, private router: Router, private activatedRoute: ActivatedRoute, private TokenService: TokenService, private GlobalService: GlobalService) {
    this.baseurl = environment.base_api;
    
    this._ForK2 = this.activatedRoute.snapshot.params.ForK2;
    this._EmpCode = !!this._EmpCode ? this._EmpCode : localStorage.getItem("EmpCode");//this.activatedRoute.snapshot.params.EmpCode;
    this._UserName = this.activatedRoute.snapshot.params.UserName;
    GlobalService.CheckPagingAccessRights();
  }

  ngOnInit() {
    this.IsSearch = false;
    this.LoadProject();
  }

  /********************* Function***********************/
  OnClickSearchProjectList() {
    this.IsSearch = true;
    this.isSearchSubmitted = true;
    this.LoadProject();
  }
  CancelSearchSection() {
    this.txtSearchProjectCode = "";
    this.txtSearchProjectName = "";
    this.IsSearch = false;
    this.isSearchSubmitted = false;
    this.LoadProject();
  }

  async LoadProject() {
    var auth_token = await this.TokenService.RefreshToken();
    if (!!auth_token) {
      this.LoadProjectList(auth_token)
        .then(
          data => {
            this.projectList = data
            if (data.length == 1 && !this.IsSearch) {
              if (!!this._ForK2 && this._ForK2 == 'Y') {
                if (!!this._EmpCode && !!this._UserName) {
                  localStorage.setItem("EmpCode", this._EmpCode);
                  localStorage.setItem("UserName", this._UserName);
                }
              }

              this.router.navigate(['report-detail'], { queryParams: { ProjectCode: data[0].ProjectCode, ProjectName: data[0].ProjectName } })
            }
          }
        )
    }
  }

  async LoadProjectList(auth_token): Promise<ProjectInfo[]> {
    
    const httpOptions = {
      headers: new HttpHeaders({
        'Content-Type': 'application/json',
        'Authorization': `Bearer ${auth_token}`
      })
    };

    let EmpCode = "";
    let UserName = "";
    if (typeof (Storage) !== "undefined") {

      EmpCode = !!this._EmpCode && this._EmpCode != "0" ? this._EmpCode : localStorage.getItem("EmpCode")
      UserName = !!this._UserName && this._UserName != "0" ? this._UserName :  localStorage.getItem("UserName")

    }

    var objJson = {};
    objJson["EmpCode"] = EmpCode

    //Get Emp Role
    let strjson = JSON.stringify(objJson);

    await this.httpClient
      .post<EmpRoleInfo[]>(this.baseurl + "Employee/GetEmployeeRoleCriteria",
        strjson, httpOptions).toPromise()
      .then(
        data => {
          this.EmpRoleList = data

          for (let item of this.EmpRoleList) {

            this.RoleCode = item.RoleCode
          }
        }
      )
    //End  Get Emp Role 

    if (this.RoleCode == "MANAGER" || this.RoleCode == "PROJECTCO" || this.RoleCode == "DIRECTOR" || this.RoleCode == "SALEDIRECTOR" || this.RoleCode == "PROJDIRECTOR" || this.RoleCode == "HRMANAGER") { // Check หัวหน้าเห็นหมด

      var objData = {};
      objData["ProjectCode"] = this.txtSearchProjectCode;
      objData["ProjectName"] = this.txtSearchProjectName;
      if (this.RoleCode == "MANAGER" || this.RoleCode == "PROJECTCO" || this.RoleCode == "HRMANAGER") objData["EmpCode"] = this._EmpCode; //filter by emp

      strjson = JSON.stringify(objData);

      this.ProjectOnPromise = this.httpClient
        .post<ProjectInfo[]>(this.baseurl + "Project/GetProjectCriteria",
          strjson, httpOptions)
        .toPromise()

    }
    else {
      
      var objData = {};
      objData["UserName"] = UserName;
      objData["EmpCode"] = EmpCode;
      objData["rowFetch"] = 0;
      objData["rowOFFSet"] = 0;
      objData["FlagDelete"] = "N";

      if (!!this.txtSearchProjectCode) {
        objData["ProjectCode"] = this.txtSearchProjectCode;
      }

      if (!!this.txtSearchProjectName) {
        objData["ProjectName"] = this.txtSearchProjectName;
      }

      strjson = JSON.stringify(objData);




      this.ProjectOnPromise = this.httpClient
        .post<ProjectInfo[]>(this.baseurl + "Project/GetProjectbyMemberCriteria",
          strjson, httpOptions)
        .toPromise()
    }

    return this.ProjectOnPromise;
  }

  displayimgProject(projectcode) {
    return "/Project/Img/" + projectcode;
  }

  GetParam(name) {

    if (Object.keys(this.activatedRoute.params).length > 0) {

    }
    const results = this.activatedRoute.queryParams.subscribe(params => {
      return params[name] || 0;
    });
    
    if (!results) {
      return 0;
    }
    return results[1] || 0;
  }

}
